require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconShadowStyle.tsx
var IconShadowStyle_exports = {};
__export(IconShadowStyle_exports, {
  default: () => IconShadowStyle_default
});
module.exports = __toCommonJS(IconShadowStyle_exports);

// src/assets/monochrome/shadowStyle.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgShadowStyle = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.2 8C12.2 10.3196 10.3196 12.2 8 12.2C5.6804 12.2 3.8 10.3196 3.8 8C3.8 5.6804 5.6804 3.8 8 3.8C10.3196 3.8 12.2 5.6804 12.2 8ZM13.7429 6.25689C12.9961 3.7933 10.7075 2 8 2C4.68629 2 2 4.68629 2 8C2 10.7075 3.7933 12.9961 6.25689 13.7429C7.00367 16.2065 9.29229 17.9998 11.9998 17.9998C15.3135 17.9998 17.9998 15.3135 17.9998 11.9998C17.9998 9.29229 16.2065 7.00367 13.7429 6.25689Z", fill: "#676F7E" }) });
var shadowStyle_default = SvgShadowStyle;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconShadowStyle.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconShadowStyle = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(shadowStyle_default, {}) });
};
IconShadowStyle.displayName = "IconShadowStyle";
var IconShadowStyle_default = IconShadowStyle;
